var map = {
	"./airbnbLogo.png": 3783,
	"./codeInLogo.webp": 7008,
	"./contactMail.webp": 9729,
	"./contactMailDark.svg": 3527,
	"./developerActivity.svg": 36,
	"./facebookLogo.png": 34,
	"./googleAssistant.svg": 760,
	"./googleAssistantLogo.webp": 2905,
	"./harvardLogo.png": 5972,
	"./jamisonphoto.jpg": 6019,
	"./jsFramework.svg": 860,
	"./manOnTable.svg": 8776,
	"./nextuLogo.webp": 2953,
	"./programmer.svg": 522,
	"./pwa.webp": 930,
	"./pwaLogo.webp": 9943,
	"./quoraLogo.png": 8967,
	"./saayaHealthLogo.webp": 7788,
	"./skill.svg": 1601,
	"./stanfordLogo.png": 7021,
	"./talksCardBack.svg": 2592,
	"./unsw.png": 9229,
	"./uow.png": 2745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;